import { v4 as uuidv4 } from 'uuid'
import { DesignSurface } from '@mcp-artwork/cimdoc-types-v2/dist/DesignSurface'
import { DesignView } from './targetSpecifications/types'
import { emptyBoundingArea, getBleedArea } from './targetSpecifications/client'

export const generateSecondaryPanel = (panel: DesignView): DesignSurface => {
  const panelId = uuidv4()
  const fullBleed = getBleedArea(panel)
  let panelWidth = fullBleed.position.width
  let panelHeight = fullBleed.position.height

  return {
    id: `${panelId}`,
    name: panel.name || 'Back',
    width: `${panelWidth}cm`,
    height: `${panelHeight}cm`,
    decorationTechnology: panel.processType || 'inkJet',
    colorMode: 'blank',
  }
}
